import { render } from "./WinLose.vue?vue&type=template&id=2a374050"
import script from "./WinLose.vue?vue&type=script&lang=js"
export * from "./WinLose.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Dev\\Vue\\guesswhat\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__